export default {"src":"/_next/static/media/FHN.3bc83d73.svg","height":18,"width":18};